<template>
  <van-divider style="margin:10px 0;"/>
  <div v-if="isShowTagFilter" class="tDoubleTagsParentDiv">
    <div style="display:flex;flex-direction: row;">
      <div @click="pressRow1Tag(null)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select1RowItem === null?'eachTagActive':'']">全部</div>
      <div class="scrollable-tags">
        <div @click="pressRow1Tag(row1Item)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select1RowItem?.Id === row1Item.Id?'eachTagActive':'']"
             style="margin-left: 6px;" v-for="row1Item in allTagInfos" :key="row1Item.Id">
          {{ row1Item.Name }}
        </div>
      </div>
    </div>
    <div v-if="select1RowItem !== null && row2TagInfos!==null" style="margin:4px 0;"/>
    <div v-if="select1RowItem !== null && row2TagInfos!==null" style="display:flex;flex-direction: row;">
      <div @click="pressRow2Tag(null)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select2RowItem === null?'eachTagActive':'']">全部</div>
      <div class="scrollable-tags">
        <div @click="pressRow2Tag(row1Item)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select2RowItem?.Id === row1Item.Id?'eachTagActive':'']"
             style="margin-left: 6px;" v-for="row1Item in row2TagInfos" :key="row1Item.Id">
          {{ row1Item.Name }}
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {watch} from "vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  let useHttp = useHHttp();
  let useUser = useUserStore();
  let isShowTagFilter = ref(false);

  let allTagInfos = ref([]);
  const select1RowItem = ref(null);
  const select2RowItem = ref(null);
  const row2TagInfos = ref([]);

  const props = defineProps(["reqPath", "startSecs", "endSecs","change","initTagId"]);

  function pressRow1Tag(row1Item) {
    if (row1Item) {
      select1RowItem.value = row1Item;
      row2TagInfos.value = row1Item["Child"];
    } else {
      select1RowItem.value = null;
      row2TagInfos.value = [];
    }
    select2RowItem.value = null;

    props.change(select1RowItem.value,select2RowItem.value);
  }

  function pressRow2Tag(row1Item) {
    if (row1Item) {
      select2RowItem.value = row1Item;
    } else {
      select2RowItem.value = null;
    }
    props.change(select1RowItem.value,select2RowItem.value);
  }

  watch(() => [props.startSecs, props.endSecs], async () => {
    updateTags();
  });

  function updateTags(){
    select1RowItem.value = null;
    select2RowItem.value = null;
    row2TagInfos.value = [];
    useHttp.request(props.reqPath, (data) => {
      allTagInfos.value = data["Data"] ?? [];
      if (allTagInfos.value.length > 0) {
        isShowTagFilter.value = true;
      }
      if(props.initTagId != null ){
        for(let i = 0;i<allTagInfos.value.length;i++){
          if(allTagInfos.value[i]["Id"] === props.initTagId){
            select1RowItem.value = allTagInfos.value[i];
            row2TagInfos.value = select1RowItem.value["Child"];
            break;
          }
        }
      }
    }, {
      params: {
        "UserId": useUser.userId,
        "BeginTime": props.startSecs,
        "EndTime": props.endSecs,
      }
    });
  }
  onMounted(() => {
    updateTags();
  });
</script>


<style scoped>
  .tDoubleTagsParentDiv {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
  }

  .scrollable-tags {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* iOS 流畅滚动 */
  }

  .eachTagDark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    background-color: #333;
    font-size: 13px;
    color: #aaa;
    border-radius: 3px;
    flex-shrink: 0;
  }

  .eachTag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    background-color: #e8e8e8;
    font-size: 13px;
    color: #444;
    border-radius: 3px;
    flex-shrink: 0;
  }

  .eachTagActive {
    background-color: var(--ct-main-color);
    color: white;
  }

  /* 桌面: 上面 .eachTag/.eachTagDark 的 font-size:13px、padding:3px 10px 会被 postcss 转成 vw、
     宽屏下放大, 使 全部/充值/提现 这排 tag 字号和内边距过大。@media 内 px 不转换, 还原真实 px。 */
  @media (min-width: 1024px) {
    .eachTag,
    .eachTagDark {
      font-size: 13px;
      padding: 3px 10px;
      border-radius: 3px;
    }

    /* 桌面: 全部/充值/提现 这几行 tag 整体居中(内容少时居中显示) */
    .tDoubleTagsParentDiv {
      align-items: center;
    }
  }
</style>
